import { WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SessionLoadErrorProps {
  onLogout: () => void;
}

/**
 * Affiché quand la lecture de `user_roles` échoue au chargement d'une des deux
 * surfaces (manager ou salarié). Distinct de `AccountSetupError` : ici le
 * compte n'a rien d'anormal, c'est la lecture qui n'a pas abouti — annoncer
 * une « configuration incomplète » à quelqu'un dont le réseau a lâché serait
 * faux et inquiétant.
 *
 * Sans rôle connu, aucune des deux surfaces ne peut décider quoi afficher :
 * c'est précisément le moment où il ne faut pas deviner.
 */
export const SessionLoadError = ({ onLogout }: SessionLoadErrorProps) => (
  <div className="min-h-screen flex items-center justify-center bg-background p-4">
    <div className="max-w-md w-full text-center space-y-6">
      <div className="mx-auto w-14 h-14 rounded-full bg-muted flex items-center justify-center">
        <WifiOff className="w-7 h-7 text-muted-foreground" />
      </div>
      <div className="space-y-2">
        <h1 className="text-xl font-semibold text-foreground">
          Impossible de charger votre espace
        </h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          La connexion au serveur n'a pas abouti. Votre compte et vos données
          ne sont pas affectés. Vérifiez votre connexion internet puis
          réessayez.
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <Button onClick={() => window.location.reload()}>Réessayer</Button>
        <Button variant="outline" onClick={onLogout}>
          Se déconnecter
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Si le problème persiste, écrivez-nous à{" "}
        <a href="mailto:contact@equiply.fr" className="text-primary hover:underline">
          contact@equiply.fr
        </a>
        .
      </p>
    </div>
  </div>
);
